import type { AdminTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const getFloors = async () => {
  const res = await Api.get<AdminTypes.FloorDto[]>('/admin/v1/floors');
  return res.data;
};
